// extracted by mini-css-extract-plugin
export default {"item":"Pagination_item__+B4I+","disabled":"Pagination_disabled__1LE7y","active":"Pagination_active__q3h4d"};